module.exports = __webpack_public_path__ + "img/014.6b12ae6c.png";